/*
 * @Author: Chao Yang
 * @Date: 2020-05-06 10:42:26
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-05-20 16:59:01
 */

import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ad-upload',
  templateUrl: './ad-upload.component.html',
  styleUrls: ['./ad-upload.component.scss'],
})
export class AdUploadComponent implements OnInit, OnDestroy {
  @Input() url = '';
  @Input() data: any;
  @Input() text = 'Choose File';
  @Input() autoUpload = true;
  @Input() onlyButton: boolean = false;
  @Input() maxFileSize: number = 20971520;
  @Input() allowedFileTypes: string[];
  @Input() allowedMimeTypes: string[];
  @ViewChild('file', { static: true })
  selectDir: ElementRef<HTMLInputElement>;
  @Output() onAddingFileFailed: EventEmitter<
    { item: FileLikeObject, filter: any, options: any, msg: string }
  > = new EventEmitter();
  uploader: FileUploader;
  subscription: Subscription;
  @Output() response: EventEmitter<any> = new EventEmitter();
  @Output() onAfterAddingFile: EventEmitter<FileItem> = new EventEmitter();

  constructor() { }
  ngOnDestroy(): void {
    this.response.complete();
    this.response.unsubscribe();
    this.response = null;
    this.subscription.unsubscribe();
    //this.uploader.destroy();
  }

  ngOnInit() {
    this.uploader = new FileUploader({
      url: this.url,
      autoUpload: this.autoUpload,
      additionalParameter: this.data,
      allowedFileType: this.allowedFileTypes || undefined,
      allowedMimeType: this.allowedMimeTypes || undefined,
      maxFileSize: this.maxFileSize
    });
    this.uploader.onAfterAddingFile = (fileItem: FileItem) => {
      this.onAfterAddingFile.emit(fileItem);
      this.selectDir.nativeElement.value = "";
      console.log(fileItem);
      return { fileItem };
    }
    this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
      let msg = "";
      if (filter.name === "fileSize") {
        let uploadedFileName = item.name;
        msg = `Your uploaded file ${uploadedFileName} exceeds the maximum size limit of ${this.maxFileSize} bytes.`;
      } else if (filter.name === "mimeType" || filter.name === "fileType") {
        let allowedFileType = (options.allowedFileType || options.allowedMimeType).join(','), uploadedFileName = item.name;
        msg = `The type of uploaded file {${uploadedFileName}} is not supported, the allowed types are: ${allowedFileType}`;
      }
      if (this.selectDir) {
        this.selectDir.nativeElement.value = "";
      }
      console.log({ item, filter, options, msg })
      this.onAddingFileFailed.emit({ item, filter, options, msg });
    };
    this.subscription = this.uploader.response.subscribe((r) => {
      this.response.emit(r);
    });
  }

  selectFile() {
    this.selectDir.nativeElement.click();
  }

  uploadAll(data: any | undefined) {
    if (data) {
      this.uploader.options.additionalParameter = data;
    }
    this.uploader.uploadAll();
  }

  getFileSize(item) {
    if (item && item.file && item.file.size) {
      return (item.file.size / 1024).toFixed(2);
    }
    return 0;
  }

  getFiles() {
    return this.uploader.queue;
  }
}
